<template>
  <div class="about">
    <div class="container">
<!--      <gantt></gantt>-->
      <EchartsComponent></EchartsComponent>
    </div>
<!--    <UserCard></UserCard>-->
  </div>
</template>

<script>
  // import UserCard from "../components/UserCard"
  import Gantt from '../components/Gantt.vue';
  import EchartsComponent from "../components/echarts";
  export default {
    name: 'app',
    components: {
      Gantt,
      EchartsComponent
    },
    data () {
      return {
      }
    }
  }
</script>

<style scoped>
  .about{
    /*background: pink;*/
  }
  .left-container{
    height: 500px;
  }
</style>

